export default __webpack_public_path__ + "static/media/dropDownOpenIconBlack.0b48d82a.svg";